import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Connects to data-controller="global-dice"
export default class extends Controller {
  static targets = ["result", "modal"]

  connect() {
    this.modal = new Modal(document.getElementById("diceModal"))
  }

  open() {
    this.modal.show()
    this.roll()
  }

  roll() {
    const result = Math.floor(Math.random() * 20) + 1
    this.resultTarget.textContent = result
    
    // Simple animation effect
    this.resultTarget.classList.remove("animate-pop")
    void this.resultTarget.offsetWidth // trigger reflow
    this.resultTarget.classList.add("animate-pop")
  }
}
